import { validateCustomGroupName } from '../../util/form-validation';

export default () => ({
  // this must match the names of the form fields
  groupName: validateCustomGroupName,
});
